<template>
  <div class="document-content-records">
    <v-divider v-if="records.length"/>
    <div v-for="(record, index) in records" :key="index">
      <div class="document-content-record">
        <p style=" border-bottom: 1px dashed gray;padding-bottom: 16px;">
          <span class="accent--text">{{ record.nomenklatura_id}}</span> {{ record.name}}
        </p>
        <div style="text-align: right;">
          <v-layout align-center>
            <v-flex xs12>{{ record.kolichestvo}} * <i>{{ record.tsena}}</i> = <i>{{ record.kolichestvo * record.tsena |
              numberFormat(2, '.', ' ')}}</i></v-flex>
          </v-layout>

        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <p class="text-xs-right document-content-record">
      Итого: <strong>{{ documentSumma | numberFormat(2, '.', ' ') }}</strong>
    </p>
  </div>
</template>

<script>
import { numericOnly } from '@/directives/numericOnly'
import numberFormat from '@/filters/numberFormat'

export default {
  name: 'RashodnayaNakladnayaList',
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  props: {
    records: {
      default: () => [],
      required: true,
      type: Array
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    documentSumma () {
      let summa = 0
      this.records.forEach(function (v) {
        summa += parseFloat(v.tsena) * parseInt(v.kolichestvo)
      })

      return summa
    }
  }
}
</script>

<style lang="stylus">
  .document-content-records {
  }

  .document-content-record {
    padding: 16px
  }

</style>
